module.exports = __webpack_public_path__ + "img/home-shebei-2.4904265b.png";